import { forwardRef, useEffect, useRef, useState } from 'react';
import { Input, InputRef } from 'antd';
import { useDebounce } from '../../useDebounce';
import { useUnifiedRef } from '../../useUnifiedRef';
import { FilterInputProps } from './FilterInputProps';

export const DefaultFilterInput = forwardRef<InputRef, FilterInputProps>(
  ({ header, onBlur }, forwardedRef) => {
    const internalRef = useRef<InputRef | null>(null);
    const unifiedRef = useUnifiedRef(forwardedRef, internalRef);

    const [internalFilterValue, setInternalFilterValue] = useState(
      () => (header.column.getFilterValue() as string | undefined) ?? '',
    );
    const filterValue = useDebounce(internalFilterValue);

    useEffect(() => {
      header.column.setFilterValue(filterValue);
    }, [filterValue]);

    return (
      <Input
        id={`${header.column.id}-filter-input`}
        ref={unifiedRef.ref}
        value={internalFilterValue}
        onChange={(event) => setInternalFilterValue(event.currentTarget.value)}
        onKeyDown={(event) => {
          // Prevent the event from bubbling up to dropdown component
          event.stopPropagation();

          // Clear the filter value and blur the filter input to effectively close its popover
          if (event.key === 'Escape') {
            header.column.setFilterValue(undefined);
            unifiedRef.current?.blur();
          }
        }}
        onBlur={onBlur}
        allowClear
      />
    );
  },
);
